export default __webpack_public_path__ + "static/media/place-point-svgrepo-com.b29af919.svg";